const C = {
  name: "ProductAdyen",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.25 12C9.25 12.69 8.69 13.25 8 13.25C7.31 13.25 6.75 12.69 6.75 12C6.75 11.31 7.31 10.75 8 10.75C8.69 10.75 9.25 11.31 9.25 12Z" fill="currentColor"/>
<path d="M12 13.25C12.69 13.25 13.25 12.69 13.25 12C13.25 11.31 12.69 10.75 12 10.75C11.31 10.75 10.75 11.31 10.75 12C10.75 12.69 11.31 13.25 12 13.25Z" fill="currentColor"/>
<path d="M13.25 16C13.25 16.69 12.69 17.25 12 17.25C11.31 17.25 10.75 16.69 10.75 16C10.75 15.31 11.31 14.75 12 14.75C12.69 14.75 13.25 15.31 13.25 16Z" fill="currentColor"/>
<path d="M17 2H2V17C2 19.7623 4.23772 22 7 22H22V7C22 4.23772 19.7623 2 17 2ZM4 10.75V4H17C18.6577 4 20 5.34228 20 7V20H13.25C13.25 19.31 12.69 18.75 12 18.75C11.31 18.75 10.75 19.31 10.75 20H7C5.34228 20 4 18.6577 4 17V13.25C4.69 13.25 5.25 12.69 5.25 12C5.25 11.31 4.69 10.75 4 10.75Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as ProductAdyen
};
